import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import CatalogsContent from "modules/Catalogs";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const CatalogsPage: React.FC = () => {
  setTitle("Physical Goods");
  return (
    <Auth>
      <Layout>
        <CatalogsContent />
      </Layout>
    </Auth>
  );
};

export default CatalogsPage;
